/**
 * 在 Nova App 的网页容器里打开时，App 在文档开始时注入的登录态（docs/Banner与网页容器.md）。
 * 有它就直接用 App 的会话令牌调接口，不走 Telegram initData；App 登录、退出、续期后会更新它并发 loginStatusChange。
 */
interface NovaContext {
  token?: string
  isLogin?: boolean
}

interface NovaBridge {
  on(event: string, handler: (data: { isLogin?: boolean; token?: string }) => void): void
}

declare global {
  interface Window {
    __NOVA__?: NovaContext
    NovaBridge?: NovaBridge
  }
}

/** App 注入的会话令牌；不在 App 里返回 null */
export function novaToken(): string | null {
  return window.__NOVA__?.token || null
}

/** App 里登录状态变了（登录、退出、续期），回调拿到新令牌 */
export function onNovaToken(handler: (token: string | null) => void): void {
  window.NovaBridge?.on('loginStatusChange', (d) => handler(d?.token || null))
}
